import { useSelector } from "react-redux"

import frameImg from "../../../assets/Images/frame.png"
import LoginForm from "./LoginForm"
import SignupForm from "./SignupForm"

function Template({ title, description1, description2, image, formType }) {
  const { loading } = useSelector((state) => state.auth)

  return (
    <div className="grid min-h-[calc(100vh-4rem)] place-items-center bg-richblack-900 font-inter">
      {loading ? (
        <div className="flex min-h-[calc(100vh-4rem)] w-full items-center justify-center">
          <div className="custom-loader" />
        </div>
      ) : (
        <div className="mx-auto flex w-11/12 max-w-maxContent flex-col-reverse justify-between gap-y-12 py-12 md:flex-row md:gap-y-0 md:gap-x-12">
          <div className="mx-auto w-11/12 max-w-[450px] rounded-2xl border border-richblack-700 bg-richblack-800 p-8 shadow-[0_0_48px_-12px_rgba(0,0,0,0.65)] md:mx-0">
            <h1 className="text-[1.875rem] font-semibold leading-[2.375rem] text-richblack-5">
              {title}
            </h1>
            <p className="mt-4 text-[1.125rem] leading-[1.625rem]">
              <span className="text-richblack-200">{description1}</span>{" "}
              <span className="font-edu-sa font-bold italic text-caribbeangreen-200">
                {description2}
              </span>
            </p>
            {formType === "signup" ? <SignupForm /> : <LoginForm />}
          </div>
          <div className="relative mx-auto w-11/12 max-w-[450px] md:mx-0">
            <img
              src={frameImg}
              alt=""
              width={558}
              height={504}
              loading="lazy"
              className="rounded-2xl opacity-90"
            />
            <img
              src={image}
              alt="StudyNotion learners"
              width={558}
              height={504}
              loading="lazy"
              className="absolute -top-4 right-4 z-10 rounded-2xl shadow-2xl shadow-black/40 ring-1 ring-richblack-600"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Template